import { render, staticRenderFns } from "./loginToggle.vue?vue&type=template&id=2ce24c45"
import script from "./loginToggle.vue?vue&type=script&lang=js"
export * from "./loginToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports